"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _classnames = _interopRequireDefault(require("classnames"));

var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));

var _ThemeProvider = require("../../ThemeProvider");

var _CreditCardsComIcon = _interopRequireDefault(require("../../assets/icons/CreditCardsComIcon"));

var _wall_street_journal = _interopRequireDefault(require("../../assets/logos/wall_street_journal.png"));

var _wall_street_journal2x = _interopRequireDefault(require("../../assets/logos/wall_street_journal-2x.png"));

var _bloomberg = _interopRequireDefault(require("../../assets/logos/bloomberg.png"));

var _bloomberg2x = _interopRequireDefault(require("../../assets/logos/bloomberg-2x.png"));

var _new_york_times = _interopRequireDefault(require("../../assets/logos/new_york_times.png"));

var _new_york_times2x = _interopRequireDefault(require("../../assets/logos/new_york_times-2x.png"));

var _entrepreneur = _interopRequireDefault(require("../../assets/logos/entrepreneur.png"));

var _entrepreneur2x = _interopRequireDefault(require("../../assets/logos/entrepreneur-2x.png"));

var _fox_business = _interopRequireDefault(require("../../assets/logos/fox_business.png"));

var _fox_business2x = _interopRequireDefault(require("../../assets/logos/fox_business-2x.png"));

var _consumer_reports = _interopRequireDefault(require("../../assets/logos/consumer_reports.png"));

var _consumer_reports2x = _interopRequireDefault(require("../../assets/logos/consumer_reports-2x.png"));

var _FaceBookIcon = _interopRequireDefault(require("../../assets/icons/FaceBookIcon"));

var _InstagramIcon = _interopRequireDefault(require("../../assets/icons/InstagramIcon"));

var _TwitterIcon = _interopRequireDefault(require("../../assets/icons/TwitterIcon"));

var _YouTubeIcon = _interopRequireDefault(require("../../assets/icons/YouTubeIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Footer =
/*#__PURE__*/
function (_Component) {
  _inherits(Footer, _Component);

  function Footer() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Footer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Footer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "siteLinkList", {
      heading: 'Site',
      links: [{
        text: 'Privacy Policy',
        href: "https://www.creditcards.com/privacy.php".concat(_this.props.uriQueryAddition),
        rel: 'nofollow'
      }, {
        text: 'California Privacy Rights',
        href: "https://www.creditcards.com/privacy.php".concat(_this.props.uriQueryAddition),
        rel: 'nofollow'
      }, {
        text: 'Terms of Use',
        href: "https://www.creditcards.com/terms.php".concat(_this.props.uriQueryAddition),
        rel: 'nofollow'
      }, {
        text: 'Site Map',
        href: "https://www.creditcards.com/site-map.php".concat(_this.props.uriQueryAddition)
      }]
    });

    _defineProperty(_assertThisInitialized(_this), "aboutLinkList", {
      heading: 'About',
      links: [{
        text: 'Overview',
        href: "https://www.creditcards.com/about-us.php".concat(_this.props.uriQueryAddition)
      }, {
        text: 'Media Center',
        href: "https://www.creditcards.com/media-recap/".concat(_this.props.uriQueryAddition)
      }, {
        text: 'Careers',
        href: "https://www.creditcards.com/careers/".concat(_this.props.uriQueryAddition)
      }]
    });

    _defineProperty(_assertThisInitialized(_this), "contactLinkList", {
      heading: 'Contact',
      links: [{
        text: 'Customer Support',
        href: "https://www.creditcards.com/customer-support-department.php".concat(_this.props.uriQueryAddition)
      }, {
        text: 'Partnership Opportunities',
        href: "http://www.bankratecreditcards.com".concat(_this.props.uriQueryAddition)
      }, {
        text: 'Business Development',
        href: "https://www.creditcards.com/business-development.php".concat(_this.props.uriQueryAddition)
      }, {
        text: 'Media Relations',
        href: "https://www.creditcards.com/public-relations.php".concat(_this.props.uriQueryAddition)
      }, {
        text: 'Contact Us',
        href: "https://www.creditcards.com/contact.php".concat(_this.props.uriQueryAddition)
      }]
    });

    _defineProperty(_assertThisInitialized(_this), "relatedLinkList", {
      heading: 'Related Sites',
      links: [{
        text: 'Credit Card Blogs',
        href: "http://blogs.creditcards.com/".concat(_this.props.uriQueryAddition)
      }, {
        text: 'CardMatch&#8482;',
        href: "https://www.creditcards.com/cardmatch/".concat(_this.props.uriQueryAddition)
      }]
    });

    _defineProperty(_assertThisInitialized(_this), "socialButtons", {
      facebook: {
        alt: 'Facebook',
        href: 'http://www.facebook.com/CreditCards.com'
      },
      twitter: {
        alt: 'Twitter',
        href: 'https://twitter.com/CreditCardsCom'
      },
      youtube: {
        alt: 'YouTube',
        href: 'http://www.youtube.com/creditcardstv'
      },
      instagram: {
        alt: 'Instagram',
        href: 'https://www.instagram.com/creditcardscom/'
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderLinkList", function (listData) {
      return _react["default"].createElement("div", {
        className: _this.props.theme.list,
        key: (0, _uniqueId["default"])()
      }, _react["default"].createElement("div", {
        className: _this.props.theme.listHeadingLink
      }, listData.heading), listData.links.map(function (link) {
        return _react["default"].createElement("a", {
          className: _this.props.theme.listLink,
          href: link.href,
          rel: link.rel ? link.rel : null,
          dangerouslySetInnerHTML: {
            __html: link.text
          },
          key: (0, _uniqueId["default"])()
        });
      }));
    });

    return _this;
  }

  _createClass(Footer, [{
    key: "render",
    value: function render() {
      return _react["default"].createElement("footer", {
        className: this.props.theme.footer
      }, _react["default"].createElement("div", {
        className: this.props.theme.content
      }, _react["default"].createElement("div", {
        className: this.props.theme.asSeenOn
      }, _react["default"].createElement("div", null, "As seen on:"), _react["default"].createElement("div", null, _react["default"].createElement("img", {
        src: _wall_street_journal["default"],
        srcSet: "".concat(_wall_street_journal["default"], " 1x, ").concat(_wall_street_journal2x["default"], " 2x"),
        alt: "Wall Street Journal"
      })), _react["default"].createElement("div", null, _react["default"].createElement("img", {
        src: _bloomberg["default"],
        srcSet: "".concat(_bloomberg["default"], " 1x, ").concat(_bloomberg2x["default"], " 2x"),
        alt: "Bloomberg"
      })), _react["default"].createElement("div", null, _react["default"].createElement("img", {
        src: _new_york_times["default"],
        srcSet: "".concat(_new_york_times["default"], " 1x, ").concat(_new_york_times2x["default"], " 2x"),
        alt: "New York Times"
      })), _react["default"].createElement("div", null, _react["default"].createElement("img", {
        src: _entrepreneur["default"],
        srcSet: "".concat(_entrepreneur["default"], " 1x, ").concat(_entrepreneur2x["default"], " 2x"),
        alt: "Entrepreneur"
      })), _react["default"].createElement("div", null, _react["default"].createElement("img", {
        src: _fox_business["default"],
        srcSet: "".concat(_fox_business["default"], " 1x, ").concat(_fox_business2x["default"], " 2x"),
        alt: "Fox Business"
      })), _react["default"].createElement("div", null, _react["default"].createElement("img", {
        src: _consumer_reports["default"],
        srcSet: "".concat(_consumer_reports["default"], " 1x, ").concat(_consumer_reports2x["default"], " 2x"),
        alt: "Consumer Reports"
      }))), _react["default"].createElement("div", {
        className: this.props.theme.links
      }, _react["default"].createElement("div", {
        className: this.props.theme.social
      }, _react["default"].createElement("div", {
        className: this.props.theme.ccLogo
      }, _react["default"].createElement(_CreditCardsComIcon["default"], {
        fill: "#005cff",
        width: "226",
        height: "24"
      })), _react["default"].createElement("div", {
        className: this.props.theme.socialIconLabel
      }, "Follow us"), _react["default"].createElement("div", {
        className: this.props.theme.socialIconList
      }, _react["default"].createElement("div", {
        className: this.props.theme.socialIcon
      }, _react["default"].createElement("a", {
        href: this.socialButtons.facebook.href,
        target: "_blank"
      }, _react["default"].createElement(_FaceBookIcon["default"], null))), _react["default"].createElement("div", {
        className: this.props.theme.socialIcon
      }, _react["default"].createElement("a", {
        href: this.socialButtons.instagram.href,
        target: "_blank"
      }, _react["default"].createElement(_InstagramIcon["default"], null))), _react["default"].createElement("div", {
        className: this.props.theme.socialIcon
      }, _react["default"].createElement("a", {
        href: this.socialButtons.twitter.href,
        target: "_blank"
      }, _react["default"].createElement(_TwitterIcon["default"], null))), _react["default"].createElement("div", {
        className: this.props.theme.socialIcon
      }, _react["default"].createElement("a", {
        href: this.socialButtons.youtube.href,
        target: "_blank"
      }, _react["default"].createElement(_YouTubeIcon["default"], null))))), _react["default"].createElement("div", {
        className: this.props.theme.listSection
      }, [this.renderLinkList(this.siteLinkList), this.renderLinkList(this.aboutLinkList), this.renderLinkList(this.contactLinkList), this.renderLinkList(this.relatedLinkList)])), _react["default"].createElement("div", {
        className: this.props.theme.legal
      }, _react["default"].createElement("div", {
        className: this.props.theme.copyright
      }, "Copyright 2018 CreditCards.com. All Rights Reserved."), _react["default"].createElement("div", {
        className: this.props.theme.disclosure
      }, "ADVERTISER DISCLOSURE CreditCards.com is an independent, advertising-supported comparison service. The offers that appear on this site are from companies from which CreditCards.com receives compensation. This compensation may impact how and where products appear on this site, including, for example, the order in which they appear within listing categories. Other factors, such as our proprietary website's rules and the likelihood of applicants' credit approval also impact how and where products appear on the site. CreditCards.com does not include the entire universe of available financial or credit offers.", this.props.ficoDisclaimer ? _react["default"].createElement("div", null, _react["default"].createElement("br", null), _react["default"].createElement("br", null), "\"CREDIT SCORES CreditCards.com credit ranges are derived from FICO\xAE Score 8, which is one of many different types of credit scores. If you apply for a credit card, the lender may use a different credit score when considering your application for credit.\"") : null))));
    }
  }]);

  return Footer;
}(_react.Component);

_defineProperty(Footer, "propTypes", {
  uriQueryAddition: _propTypes["default"].string,
  theme: _propTypes["default"].object,
  ficoDisclaimer: _propTypes["default"].bool
});

_defineProperty(Footer, "defaultProps", {
  uriQueryAddition: '',
  ficoDisclaimer: true
});

var _default = (0, _ThemeProvider.applyTheme)('Footer', Footer);

exports["default"] = _default;